<p class="ui-heading-2-bold--s">Booking Request</p>

<rds-accordion size="m">
  <rds-expansion-panel [(expanded)]="filtersExpanded">
    <rds-expansion-panel-header>
      <rds-panel-title>
        <h2 class="rds-expansion-panel-heading">Filters</h2>
      </rds-panel-title>
    </rds-expansion-panel-header>
    <form [formGroup]="filterForm">
      <div class="search row gy-5 align-items-end">
        <div class="col-12 col-l-8">
          <label for="searchInput" class="filter-label">Search phrase</label>
          <rds-search
            id="searchInput"
            placeholder="Search Room, Bookly ID, event name or requester"
            formControlName="searchPhrase"
            autoSearch="true"
            size="m"></rds-search>
        </div>

        <div class="col-12 col-l-4">
          <rds-form-field labelPosition="top" size="m">
            <rds-control-label>Service</rds-control-label>
            <rds-multi-select
              placeholder="Select Service"
              formControlName="services"
              (openChange)="onMultiSelectClose($event)">
              @for (service of services(); track service) {
                <rds-multi-select-option [value]="service.type">{{
                  service.name
                }}</rds-multi-select-option>
              }
            </rds-multi-select>
          </rds-form-field>
        </div>
      </div>
      <div class="filter-row row gy-5 align-items-end">
        <div class="col-12 col-m-6 col-l-3">
          <rds-form-field labelPosition="top" size="m">
            <rds-control-label>Site</rds-control-label>
            <rds-multi-select
              formControlName="siteNames"
              placeholder="Select Site"
              (openChange)="onMultiSelectClose($event)">
              @for (site of siteNames(); track site) {
                <rds-multi-select-option [value]="site">{{
                  site
                }}</rds-multi-select-option>
              }
            </rds-multi-select>
          </rds-form-field>
        </div>
        <div class="col-12 col-m-6 col-l-3">
          <rds-form-field labelPosition="top" size="m">
            <rds-control-label>Building</rds-control-label>
            <rds-multi-select
              formControlName="buildingNames"
              placeholder="Select Building"
              (openChange)="onMultiSelectClose($event)">
              @for (building of buildingNames(); track building) {
                <rds-multi-select-option [value]="building">{{
                  building
                }}</rds-multi-select-option>
              }
            </rds-multi-select>
          </rds-form-field>
        </div>
        <div class="col-12 col-m-6 col-l-3">
          <rds-form-field labelPosition="top" size="m">
            <rds-control-label>Floor</rds-control-label>
            <rds-multi-select
              formControlName="floorNames"
              placeholder="Select Floor"
              (openChange)="onMultiSelectClose($event)">
              @for (floor of floorNames(); track floor) {
                <rds-multi-select-option [value]="floor">{{
                  floor
                }}</rds-multi-select-option>
              }
            </rds-multi-select>
          </rds-form-field>
        </div>
        <div class="col-12 col-m-6 col-l-3">
          <button
            rds-secondary-button
            type="button"
            (click)="clearFilters()"
            size="m"
            class="clear-button">
            Clear
          </button>
        </div>
      </div>
    </form>
  </rds-expansion-panel>
</rds-accordion>

<rds-tabs
  ariaLabel="Booking request status tabs"
  (selectedTabChange)="handleTabChange($event)">
  <rds-tab label="Awaiting Approval">
    @if (!isRoomBookingDataLoading()) {
      <bad-room-bookings-table
        [roomBooking]="allBookings()"
        [paginationState]="paginationState()"
        (rowClicked)="clickRowHandler($event)"
        (pageChanged)="handlePageChange($event)"
        (sortChanged)="handleSortChange($event)"></bad-room-bookings-table>
    } @else {
      <div class="loader">
        <rds-progress-spinner></rds-progress-spinner>
      </div>
    }
  </rds-tab>
  <rds-tab label="Approved">
    @if (!isRoomBookingDataLoading()) {
      <bad-room-bookings-table
        [roomBooking]="allBookings()"
        [paginationState]="paginationState()"
        (rowClicked)="clickRowHandler($event)"
        (pageChanged)="handlePageChange($event)"
        (sortChanged)="handleSortChange($event)"></bad-room-bookings-table>
    } @else {
      <div class="loader">
        <rds-progress-spinner></rds-progress-spinner>
      </div>
    }
  </rds-tab>
  <rds-tab label="All Bookings">
    @if (!isRoomBookingDataLoading()) {
      <bad-room-bookings-table
        [roomBooking]="allBookings()"
        [paginationState]="paginationState()"
        (rowClicked)="clickRowHandler($event)"
        (pageChanged)="handlePageChange($event)"
        (sortChanged)="handleSortChange($event)"></bad-room-bookings-table>
    } @else {
      <div class="loader">
        <rds-progress-spinner></rds-progress-spinner>
      </div>
    }
  </rds-tab>
</rds-tabs>
